import { api } from 'helpers'
import { ARC_MOSAICO_ENDPOINTS } from 'api/arcMosaico/endpoints'
import type { TrackerResponse, TrackerStudentsResponse } from './types'

function assertAuthenticated(response: { status: number }): void {
  if (response.status === 401) {
    window.location.href = '/error_permission'
    throw new Error('Unauthorized')
  }
}

export const fetchTrackerStudents = async (projectId: string): Promise<TrackerStudentsResponse> => {
  const response = await api.get<TrackerStudentsResponse>(
    ARC_MOSAICO_ENDPOINTS.projects.developmentTrackerStudents(projectId),
  )
  assertAuthenticated(response)
  return response.data
}

export const fetchDevelopmentTracker = async (
  projectId: string,
  studentId?: string,
): Promise<TrackerResponse> => {
  const response = await api.get<TrackerResponse>(
    ARC_MOSAICO_ENDPOINTS.projects.developmentTracker(projectId),
    { params: studentId ? { student_id: studentId } : undefined },
  )
  assertAuthenticated(response)
  return response.data
}
